<template>
  <div>
    <div>
      <div class="d-flex justify-space-between">
        <h1 class="font-24 font-lg-28 font-weight-bold primary--text">
          Your details
        </h1>
        <BaseButton
          :text="$vuetify.breakpoint.lgAndUp ? 'Save &amp; exit' : 'Save'"
          flat
          depressed
          ripple
          class="font-weight-bold px-1 py-3"
          icon="mdi-content-save"
          color="#106175"
          small
          @click="toggleGlobalSaveAndExitDialog"
        />
      </div>
    </div>

    <!-- the form -->
    <ValidationObserver ref="observerFormDetails">
      <form @submit.prevent="onSubmit">
        <BaseLabel :text="LABEL_CONSTANTS.TITLE_LABEL" class="mt-10 mb-2" />
        <BaseSelect
          dense
          v-model="questionApplicant1Title.Value"
          :items="applicant1TitleOptions"
          :data-uiid="questionApplicant1Title.InterfaceKey"
          :isEnableSortOrderListItems="false"
          :hide-details="false"
          :selectedDefault="LABEL_CONSTANTS.SELECT_DEFAULT_PLACEHOLDER"
          :rules="{
            required: {
              required: true,
              fieldLabel: LABEL_CONSTANTS.TITLE_LABEL,
            },
          }"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '280px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          aria-label="Title"
        />
        <BaseLabel :text="LABEL_CONSTANTS.FIRST_NAME_LABEL" class="mt-3 mb-2" />
        <BaseInput
          v-model="questionApplicant1Forename.Value"
          vid="Applicant1Forename"
          :data-uiid="questionApplicant1Forename.InterfaceKey"
          :hide-details="false"
          :rules="applicantFirstNameRules"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          aria-label="First Name"
        />

        <BaseLabel :text="LABEL_CONSTANTS.LAST_NAME_LABEL" class="mt-3 mb-2" />
        <BaseInput
          v-model="questionApplicant1Surname.Value"
          vid="Applicant1Surname"
          :data-uiid="questionApplicant1Surname.InterfaceKey"
          :hide-details="false"
          :rules="applicantLastNameRules"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          aria-label="Last Name"
        />

        <BaseLabel
          :text="LABEL_CONSTANTS.DATE_OF_BIRTH_LABEL"
          class="mt-3 mb-2"
        />
        <BaseInputDate
          vid="Applicant1DoB"
          :data-uiid="questionApplicant1DoB.InterfaceKey"
          :value="questionApplicant1DoB.Value"
          v-model="questionApplicant1DoB.Value"
          :rules="applicantDateOfBirthRules"
          :hideDetails="false"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
        />

        <BaseButton
          depressed
          rounded
          dense
          class="font-weight-bold font-20 pa-7 px-13 mt-3 primary--text"
          type="submit"
          :color="'psorange'"
          :block="$vuetify.breakpoint.lgAndUp ? false : true"
          :text="
            $vuetify.breakpoint.lgAndUp
              ? 'CONTINUE TO PROPERTY DETAILS'
              : 'CONTINUE'
          "
        />
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { EventBus } from "@/common/eventbus.js";
import { addFieldLabel, scrollTop, tryGoToNextStep } from "@/common/utils";
import { ROUTE_NAME } from "@/constants/route.constants";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapActions, mapState } from "vuex";

import {
  APPLICANT_TITLE_ITEMS_PLUS_MX,
  setItemDataUiids,
} from "@/constants/component.constants";
import * as LABEL_CONSTANTS from "@/constants/label.constants";
import {
  ERROR_INVALID,
  ERROR_MSG_MAX_CHARACTER,
  ERROR_NAME_INVALID,
} from "@/constants/message.constants.js";
import { DATE_REGEX, NAME_REGEX } from "@/constants/regex-patterns.constants";

import BaseButton from "@/components/BaseComponents/BaseButton";
import BaseInput from "@/components/BaseComponents/BaseInput";
import BaseInputDate from "@/components/BaseComponents/BaseInputDate";
import BaseLabel from "@/components/BaseComponents/BaseLabel";
import BaseSelect from "@/components/BaseComponents/BaseSelect";
import { ValidationObserver } from "vee-validate";

export default {
  name: "YourDetailsPage",
  components: {
    ValidationObserver,
    BaseLabel,
    BaseSelect,
    BaseButton,
    BaseInput,
    BaseInputDate,
  },
  data() {
    return {
      questionApplicant1DoB: {},
      questionApplicant1Forename: {},
      questionApplicant1Surname: {},
      questionApplicant1Title: {},
      NAME_REGEX,
      DATE_REGEX,
      LABEL_CONSTANTS,
      ERROR_NAME_INVALID,
      ERROR_MSG_MAX_CHARACTER,
      ERROR_INVALID,
      APPLICANT_TITLE_ITEMS_PLUS_MX,
      applicantDateOfBirthRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          date_valid: {
            errorMessageTemplate: ERROR_INVALID,
          },
          regex: {
            errorMessageTemplate: ERROR_INVALID,
            pattern: DATE_REGEX,
          },
          age_in_range: {
            min: 18,
            max: 105,
          },
        },
        LABEL_CONSTANTS.DATE_OF_BIRTH_LABEL
      ),
      applicantFirstNameRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          max: {
            length: 50,
            errorMessageTemplate: ERROR_MSG_MAX_CHARACTER,
          },
          min_length: {
            length: 2,
          },
          regex: {
            pattern: NAME_REGEX,
            customMessage: ERROR_NAME_INVALID,
          },
        },
        LABEL_CONSTANTS.FIRST_NAME_LABEL
      ),
      applicantLastNameRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          max: {
            length: 100,
            errorMessageTemplate: ERROR_MSG_MAX_CHARACTER,
          },
          min_length: {
            length: 2,
          },
          regex: {
            pattern: NAME_REGEX,
            customMessage: ERROR_NAME_INVALID,
          },
        },
        LABEL_CONSTANTS.LAST_NAME_LABEL
      ),
    };
  },
  computed: {
    ...mapState(QUESTIONS_MODULE, ["questionMap", "restoringLastStep"]),
    applicant1TitleOptions() {
      return setItemDataUiids(
        "Applicant1Title",
        this.APPLICANT_TITLE_ITEMS_PLUS_MX
      );
    },
  },
  beforeMount() {
    this.onSetupAndLoadSavedData();
    scrollTop();
  },
  mounted() {
    this.setCurrentRefObserverForm(this.$refs.observerFormDetails);

    if (!this.restoringLastStep) {
      return;
    }

    // work around running validate before the data has been added to input
    setTimeout(async () => {
      tryGoToNextStep(
        this.$refs.observerFormDetails,
        async (form) => await form.validate(),
        ROUTE_NAME.TENANTS_LIABILITY.B2B.PROPERTY_DETAILS
      );
    }, 0);
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, [
      "saveProgress",
      "toggleGlobalSaveAndExitDialog",
      "setCurrentRefObserverForm",
      "refreshSessionAndNextStep",
    ]),

    onSetupAndLoadSavedData() {
      this.questionApplicant1DoB = this.questionMap.Applicant1DoB;
      this.questionApplicant1Forename = this.questionMap.Applicant1Forename;
      this.questionApplicant1Surname = this.questionMap.Applicant1Surname;
      this.questionApplicant1Title = this.questionMap.Applicant1Title;
    },

    async onSubmit() {
      const isValidForm = await this.$refs.observerFormDetails.validate();

      if (!isValidForm) {
        EventBus.$emit("validation-error", "Validation error occurred");
        return;
      }

      this.saveProgress();
      this.refreshSessionAndNextStep(
        ROUTE_NAME.TENANTS_LIABILITY.B2B.PROPERTY_DETAILS
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
